// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"a96p_PDC","title":"I87VrB5W","description":"DjpvjpqF","row":"ujYIg1Wq","text":"ZKMYvwS7","sub":"TSkMWCgz"};